module.exports = __webpack_public_path__ + "static/media/tab-1.6792e78f.png";